import { render, staticRenderFns } from "./folder-dialog.vue?vue&type=template&id=0cf13e17"
import script from "./folder-dialog.ts?vue&type=script&lang=js&external"
export * from "./folder-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports